var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3888",
    "data-name": "Group 3888",
    transform: "translate(15796 -8566)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2981",
    "data-name": "Rectangle 2981",
    width: 16,
    height: 16,
    transform: "translate(-15796 8566)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "checked",
    d: "M7,0a7,7,0,1,0,7,7A7,7,0,0,0,7,0ZM5.716,10.6,2.634,7.514,3.661,6.486,5.716,8.541l4.623-4.623,1.027,1.027Z",
    transform: "translate(-15795 8567)",
    fill: "#45ad4e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.bd49d1b727390de2c2d5df9f3ed7a9b0.svg";
export { ForwardRef as ReactComponent };